
export enum OrderChangedState
{
    Created = 0,
    Updated = 1,
    Completed = 2,
    Expired = 3,
    Deleted = 4
}
